import { render, staticRenderFns } from "./LSelectFav.vue?vue&type=template&id=e564d318"
import script from "./LSelectFav.vue?vue&type=script&lang=js"
export * from "./LSelectFav.vue?vue&type=script&lang=js"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./LSelectFav.vue?vue&type=style&index=1&id=e564d318&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports